import React from "react";
import RequiredDot from "./RequiredDot";
import TextField from "./TextField";
import Label, { LabelProps } from "./Label";

type PropsType = {
  ariaDescribedBy?: string;
  autoComplete?: string;
  label: LabelProps["children"];
  name: string;
  placeholder?: string;
  required?: boolean;
  value?: string;
};

function TextFieldWithLabel({
  ariaDescribedBy,
  autoComplete,
  label,
  name,
  placeholder,
  required = false,
}: PropsType) {
  return (
    <div className="w-full">
      <div className="flex mb-1">
        <Label name={name}>{label}</Label>
        {required && <RequiredDot />}
      </div>
      <TextField
        autoComplete={autoComplete}
        name={name}
        placeholder={placeholder}
        ariaDescribedBy={ariaDescribedBy}
      />
    </div>
  );
}

export default TextFieldWithLabel;
